import MarketingLayout from './_layout';

const sections = [
  {
    heading: '1. Acceptance of terms',
    body: 'By creating a Messego account or using any part of the service, you agree to these Terms of Service and to our Privacy Policy. If you do not agree, you must not use Messego.',
  },
  {
    heading: '2. Eligibility',
    body: 'You must be at least 18 years old and legally capable of entering into a binding contract. Business accounts must be created by an authorized representative of the entity.',
  },
  {
    heading: '3. Your account',
    body: 'You are responsible for keeping your login credentials confidential and for all activity that occurs under your account. Notify us immediately if you suspect unauthorized access.',
  },
  {
    heading: '4. Acceptable use',
    body: 'You agree not to use Messego for any unlawful purpose, including fraud, harassment, money laundering, or sanctions evasion. We may suspend or terminate accounts that violate these terms or applicable law.',
  },
  {
    heading: '5. Fees',
    body: 'Fees applicable to your subscription or transactions are disclosed in the app and on our pricing page. We may change fees with reasonable advance notice as permitted by applicable regulation.',
  },
  {
    heading: '6. Limitation of liability',
    body: 'To the maximum extent permitted by law, Messego will not be liable for indirect, incidental, special, or consequential damages arising from your use of the service. Nothing in these terms limits liability that cannot be excluded by law.',
  },
  {
    heading: '7. Termination',
    body: 'You may close your account at any time. We may suspend or terminate your account for breach of these terms, suspected fraud, regulatory requirement, or extended inactivity, with notice where reasonably practicable.',
  },
  {
    heading: '8. Governing law',
    body: 'These terms are governed by the laws of England and Wales. Disputes will be resolved in the courts of England and Wales unless mandatory local law requires otherwise.',
  },
  {
    heading: '9. Changes',
    body: 'We may update these terms from time to time. Material changes will be communicated to you in the app or by email at least 30 days before they take effect, except where a shorter period is required by law.',
  },
];

export default function TermsOfServicePage() {
  return (
    <MarketingLayout
      title="Terms of Service"
      subtitle="Last updated: 2026-04-01. Please read these terms carefully before using Messego."
    >
      <article className="space-y-8">
        <p className="text-neutral-500 dark:text-neutral-400 leading-relaxed">
          These Terms of Service form a binding contract between you and Messego Inc. ("Messego", "we", "us"). They
          govern your access to and use of the Messego apps, website, and related services.
        </p>
        {sections.map((s, i) => (
          <section key={i} className="space-y-3">
            <h2 className="text-xl font-bold">{s.heading}</h2>
            <p className="text-neutral-500 dark:text-neutral-400 leading-relaxed">{s.body}</p>
          </section>
        ))}
      </article>
    </MarketingLayout>
  );
}
